import { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import EditClubDetailsModal from "./EditClubDetailsModal";
import { useGlobalStates } from "../../utlis/ClubsContext";
import { callApi } from "../../services/ApiServices";
import { UserRole } from "../../utlis/constant";

const GenderDistributionChart = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [chartData, setChartData] = useState([
    { name: "Female", value: 0, color: "#1f7f7d" },
    { name: "Male", value: 0, color: "#4fc4be" },
  ]);
  const [isLoading, setIsLoading] = useState(false);

  const { selectedClub, handleSelectedClubDetail, userRole } = useGlobalStates();
  useEffect(() => {
    setChartData([
      {
        name: "Female",
        value: selectedClub?.femaleDistribution || 0,
        color: "#1f7f7d",
      },
      {
        name: "Male",
        value: selectedClub?.maleDistribution || 0,
        color: "#4fc4be",
      },
    ]);
  }, [selectedClub]);
  const totalMembers = selectedClub?.clubTotalMembers || 0;
  const femaleGroup = chartData.find((item) => item.name === "Female");

  const handleCloseModal = () => {
    setIsEditing(false);
  };

  const handleSaveModal = async (data) => {
    try {
      setIsLoading(true);
      const res = await callApi({
        method: "put",
        url: `club/update/${selectedClub?.id}`,
        data: {
          fields: {
            maleDistribution: data.male,
            femaleDistribution: data.female,
          },
        },
      });
      console.log("gender respo", res);
      if (res.status === 200) {
        handleSelectedClubDetail(selectedClub);
      }
    } catch (error) {
      console.log("save gender distribution error", error);
    } finally {
      setIsLoading(false);
    }
    setIsEditing(false);
  };

  return (
    <>
      <div className="bg-[#F7FBFC] border border-[#d8ebee] rounded-xl p-6 main-shadow h-full">
        <div className="flex items-center justify-between gap-3 mb-6">
          <h2 className="text-xl md:text-xl font-medium text-black leading-tight">
            Gender Split
          </h2>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setIsEditing(true)}
              disabled={userRole === UserRole.Viewer}
              className={`flex items-center ${
                userRole === UserRole.Viewer
                  ? "cursor-not-allowed opacity-50"
                  : "cursor-pointer hover:bg-[#e7f3f6]"
              } gap-1 text-sm font-medium text-[#145463] px-2 py-1 rounded-md transition-colors`}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Edit
            </button>
          </div>
        </div>
        
        <div className="flex min-h-[240px] flex-col gap-4 pt-3 sm:flex-row sm:gap-6">
          <div className="relative h-[200px] w-full shrink-0 focus:outline-none sm:h-[220px] sm:w-1/2">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={chartData}
                  cx="50%"
                  cy="50%"
                  innerRadius={56}
                  outerRadius={82}
                  startAngle={90}
                  endAngle={-270}
                  paddingAngle={0}
                  dataKey="value"
                  stroke="none"
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip 
                position={{x:100, y:150}}
                formatter={(value, name) => [`${value}%`, name]} />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
              <p className="text-3xl font-semibold text-[#111111] leading-none">
                {Math.round(femaleGroup?.value || 0)}%
              </p>
              <p className="text-base text-[#5e6e74] leading-tight">
                {femaleGroup?.name || "N/A"}
              </p>
            </div>
          </div>

          <div className="flex w-full flex-col justify-center space-y-4 sm:w-1/2">
            {chartData.map((item) => {
              const members = Math.round((Number(totalMembers) * Number(item.value)) / 100);
              return (
                <div key={item.name}>
                  <div className="flex items-center gap-2 text-[#111111]">
                    <span
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: item.color }}
                    />
                    <span className="text-lg font-medium leading-none">
                      {item.name}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-[#2e3b40] mt-1">
                    {item.value}%
                     {/* - {members.toLocaleString()} members */}
                  </p>
                  <div className="mt-2 h-1 w-full overflow-hidden rounded-full bg-[#b9e5e8]">
                    <div
                      className="h-full rounded-full"
                      style={{
                        width: `${item.value}%`,
                        backgroundColor: item.color,
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {isEditing && (
        <EditClubDetailsModal
          onClose={handleCloseModal}
          onSave={handleSaveModal}
          initialData={{
            male: selectedClub?.maleDistribution,
            female: selectedClub?.femaleDistribution,
          }}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default GenderDistributionChart;
